import { render, staticRenderFns } from "./FollowInterestChangeActivationType.vue?vue&type=template&id=4df83aa8&"
import script from "./FollowInterestChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./FollowInterestChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports